import SolidSeparator from './SolidSeparator';

export default SolidSeparator;
